import * as React from 'react'
import { createSelectOption } from '@helpers/utils'
import { HousekeepingOrderTableHeaderStatus } from '@modules/housekeeping/common/table-headers/table-header-status'

const HousekeepingImprovementOrderStatusOptions = [
  ['NEW', 'do zlecenia'],
  ['PENDING', 'zlecone'],
  ['FINISHED', 'zakończony'],
]

const selectOptions = HousekeepingImprovementOrderStatusOptions.map(([key, name]) => createSelectOption(name, key))

export const HousekeepingImprovementOrderTableHeaderStatus = (): JSX.Element => (
  <HousekeepingOrderTableHeaderStatus name="status" options={selectOptions} placeholder="Status" />
)
